<div class="pacman-app" #gameBoard tabindex="0" aria-label="Pac-Man game board">
	<!-- HUD -->
	<div class="hud">
		<div class="hud-block">
			<span class="hud-label">Score</span>
			<span class="hud-value">{{ score }}</span>
		</div>
		<div class="hud-block">
			<span class="hud-label">High</span>
			<span class="hud-value">{{ highScore }}</span>
		</div>
		<div class="hud-block">
			<span class="hud-label">Level</span>
			<span class="hud-value">{{ level }}</span>
		</div>
		<div class="hud-block">
			<span class="hud-label">Time</span>
			<span class="hud-value">{{ formattedTime }}</span>
		</div>
		<div class="hud-block lives">
			<span class="hud-label">Lives</span>
			<span class="life-icons">
				<span class="life" *ngFor="let l of livesArray; trackBy: trackByIndex"></span>
			</span>
		</div>
	</div>

	<!-- Board (scaled as a whole on small screens) -->
	<div class="board-scaler">
		<div
			class="game-container"
			(pointerdown)="onBoardPointerDown($event)"
			(pointerup)="onBoardPointerUp($event)"
		>
			<!-- Maze -->
			<ng-container *ngFor="let row of maze; let rowIndex = index; trackBy: trackByIndex">
				<div
					*ngFor="let cell of row; let colIndex = index; trackBy: trackByIndex"
					class="maze-cell"
					[ngClass]="{ wall: cell === 1, path: cell === 0 }"
					[ngStyle]="{ 'top.px': rowIndex * gridSize, 'left.px': colIndex * gridSize }"
				></div>
			</ng-container>

			<!-- Pellets -->
			<div
				*ngFor="let pellet of pellets; trackBy: trackByIndex"
				class="pellet"
				[class.power]="pellet.power"
				[ngStyle]="{ 'top.px': pellet.top, 'left.px': pellet.left }"
			></div>

			<!-- Pac-Man -->
			<div
				class="pacman"
				[class.moving]="gameState === 'playing' && pacDir !== 'none'"
				[class.dying]="gameState === 'dying'"
				[ngStyle]="{ 'top.px': pacman.top, 'left.px': pacman.left, transform: pacRotation }"
			></div>

			<!-- Ghosts -->
			<div
				*ngFor="let ghost of ghosts; trackBy: trackByIndex"
				class="ghost"
				[class.frightened]="ghost.frightened && !ghost.eaten"
				[class.flashing]="ghostFlashing(ghost)"
				[class.eaten]="ghost.eaten"
				[attr.data-dir]="ghost.dir"
				[ngStyle]="{ 'top.px': ghost.top, 'left.px': ghost.left, '--ghost-color': ghost.color }"
			>
				<span class="eye left"></span>
				<span class="eye right"></span>
			</div>

			<!-- Floating score popups -->
			<div
				*ngFor="let popup of popups; trackBy: trackByPopup"
				class="popup"
				[ngStyle]="{ 'top.px': popup.top, 'left.px': popup.left }"
			>{{ popup.text }}</div>

			<!-- Overlays -->
			<div class="overlay" *ngIf="gameState === 'ready'">
				<div class="overlay-card">
					<div class="overlay-title ready">Ready!</div>
					<div class="overlay-sub">Use the arrow keys or the pad to start</div>
				</div>
			</div>
			<div class="overlay" *ngIf="gameState === 'paused'">
				<div class="overlay-card">
					<div class="overlay-title">Paused</div>
					<div class="overlay-sub">Press Space / P to resume</div>
				</div>
			</div>
			<div class="overlay" *ngIf="gameState === 'levelclear'">
				<div class="overlay-card">
					<div class="overlay-title win">Level {{ level }} clear!</div>
					<div class="overlay-sub">Get ready for the next one…</div>
				</div>
			</div>
			<div class="overlay" *ngIf="gameState === 'gameover'">
				<div class="overlay-card">
					<div class="overlay-title over">Game Over</div>
					<div class="overlay-sub">Score {{ score }} · High {{ highScore }}</div>
					<button class="overlay-btn" type="button" (click)="restartGame()">Play again</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Controls -->
	<div class="controls">
		<div class="dpad" aria-label="Movement controls">
			<button class="dpad-btn up" type="button" aria-label="Up" (click)="queueDir('up')">▲</button>
			<button class="dpad-btn left" type="button" aria-label="Left" (click)="queueDir('left')">◀</button>
			<button class="dpad-btn right" type="button" aria-label="Right" (click)="queueDir('right')">▶</button>
			<button class="dpad-btn down" type="button" aria-label="Down" (click)="queueDir('down')">▼</button>
		</div>
		<div class="action-btns">
			<button class="action-btn" type="button" (click)="togglePause()" [disabled]="gameState === 'gameover'">
				{{ gameState === 'paused' ? 'Resume' : 'Pause' }}
			</button>
			<button class="action-btn" type="button" (click)="restartGame()">Restart</button>
			<button class="action-btn ghost-btn" type="button" (click)="toggleSound()" [attr.aria-pressed]="soundOn">
				{{ soundOn ? '🔊 Sound' : '🔇 Muted' }}
			</button>
		</div>
	</div>
</div>
